/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DescriptorForResourceRecommendation extends models.DescriptorForRecommendation {
    getFixupPrototypeFunction() { return DescriptorForResourceRecommendation.fixupPrototype; }

    static newInstance(model: Partial<DescriptorForResourceRecommendation>): DescriptorForResourceRecommendation {
        let obj = Object.assign(new DescriptorForResourceRecommendation(), model);
        DescriptorForResourceRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DescriptorForResourceRecommendation>): DescriptorForResourceRecommendation {
        if (!model) return null;
        return DescriptorForResourceRecommendation.newInstance(<DescriptorForResourceRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DescriptorForResourceRecommendation) {
        if (!obj) return;

        models.DescriptorForResourceRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DescriptorForResourceRecommendation): boolean {
        if (models.DescriptorForRecommendation.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DescriptorForResourceRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.inventory_tags) {
            for (let val of this.inventory_tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Resource ID
     */
    resource_id: string;

    /**
     * Resource Name
     */
    resource_name: string;

    /**
     * service resource uri of the recommendation definition
     */
    service_resource_uri: string;

    /**
     * id for the resource inventory
     */
    inventory_id: string;

    /**
     * region for the resource
     */
    resource_location: string;

    /**
     * Global filter for the resource
     */
    resource_filter: string;

    /**
     * List of tag key/value pairs
     */
    inventory_tags: Array<models.KeyValuePair>;

}
